import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { NoteComponent } from '../note/note.component';

@Component({
  selector: 'era-notes-list',
  templateUrl: './notes-list.component.html',
  styleUrls: ['./notes-list.component.scss'],
  imports: [NoteComponent],
})
export class NotesListComponent {
  @Input() notes: Note[];

  @Output() private readonly noteUpdated: EventEmitter<Note> = new EventEmitter<Note>();
  @Output() private readonly noteRemoved: EventEmitter<Note> = new EventEmitter<Note>();

  public noteAdded(note: Note): void {
    this.noteUpdated.emit(note);
  }

  public noteDeleted(note: Note): void {
    this.noteRemoved.emit(note);
  }
}
